module.exports = __webpack_public_path__ + "static/United-Kingdom-68165e29b1d97cd9eba620e9b1ce8422.jpg";